import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SemRegistroComponent } from '../sem-registro/sem-registro';
import { AudioPlayerComponent } from '../audio-player/audio-player';
import { ImagePipe } from 'src/app/pipes/image/image';

@Component({
  selector: 'app-noticia-audios',
  templateUrl: './noticia-audios.page.html',
  styleUrls: ['./noticia-audios.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SemRegistroComponent,
    AudioPlayerComponent,
    TranslateModule,
    ImagePipe
  ],
})
export class NoticiaAudiosPage implements OnInit {
  audio: any = [];
  audios: any = [];
  image: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public modalCtrl: ModalController
  ) {
    this.audios = navParams.get('audios');
    this.image = navParams.get('image');
    this.audio = this.audios.length > 0 ? this.audios[0] : {};
  }

  ngOnInit() { }

  openAudio(audio: any) {
    this.audio = audio;

    setTimeout(() => {
      this.loadingController.dismiss();
    }, 3000);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
